<template>
  <div class="overflow-scroll-table">
    <table class="responsive-table">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.id" @click="onSort(col.id)">
            {{ col.display_label }}
            <font-awesome-icon :icon="['fas', 'sort']" class="icon alt" />
            <span
              v-if="col.id === sortedColumn"
              :class="sortedAsc ? 'active-up' : 'active-down'"
            >
              <font-awesome-icon
                :icon="['fas', 'sort-down']"
                class="icon alt"
              />
              <font-awesome-icon :icon="['fas', 'sort-up']" class="icon alt" />
            </span>
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in colleges" :key="row.id">
          <td>
            {{ row.name }}
            <label class="d-block d-md-none">
              {{ columns[0].display_label }}:
            </label>
          </td>

          <td>
            {{ row.report.num_students_registered | number }}
            <label class="d-block d-md-none">
              {{ columns[1].display_label }}:
            </label>
          </td>

          <td>
            {{ row.report.num_students_who_have_scheduled_a_session | number }}
            <label class="d-block d-md-none">
              {{ columns[2].display_label }}:
            </label>
          </td>

          <td>
            {{ row.report.num_counselors_registered | number }}
            <label class="d-block d-md-none">
              {{ columns[3].display_label }}:
            </label>
          </td>

          <td>
            {{ row.report.num_individual_sessions_scheduled | number }}
            <label class="d-block d-md-none">
              {{ columns[4].display_label }}:
            </label>
          </td>

          <td>
            {{ row.report.num_group_sessions_scheduled | number }}
            <label class="d-block d-md-none">
              {{ columns[5].display_label }}:
            </label>
          </td>

          <td>
            {{ row.report.num_college_events_scheduled | number }}
            <label class="d-block d-md-none">
              {{ columns[6].display_label }}:
            </label>
          </td>

          <td v-if="row.report.initial_individual_session_credits">
            {{ row.report.current_individual_session_credits | number }} of
            {{ row.report.initial_individual_session_credits | number }} left
            <label class="d-block d-md-none">
              {{ columns[7].display_label }}:
            </label>
          </td>
          <td v-else />

          <td v-if="row.report.initial_group_session_credits">
            {{ row.report.current_group_session_credits | number }} of
            {{ row.report.initial_group_session_credits | number }} left
            <label class="d-block d-md-none">
              {{ columns[8].display_label }}:
            </label>
          </td>
          <td v-else />

          <td class="icons">
            <button
              v-b-tooltip.hover.top="'Send Message'"
              type="button"
              class="fa-btn"
              title="Send Message"
              @click="sendMessage({ school: row })"
            >
              <font-awesome-icon :icon="['fas', 'envelope']" class="icon alt" />
            </button>
            <button
              v-b-tooltip.hover.top="'View College'"
              type="button"
              class="fa-btn"
              title="View College"
              @click="viewCollege(row)"
            >
              <font-awesome-icon :icon="['fas', 'file-alt']" class="icon alt" />
            </button>
            <button
              v-b-tooltip.hover.top="'Edit College'"
              type="button"
              class="fa-btn"
              title="Edit College"
              @click="editCollege(row)"
            >
              <font-awesome-icon :icon="['fas', 'edit']" class="icon alt" />
            </button>
            <router-link
              v-b-tooltip.hover.top="'College Dashboard'"
              class="fa-btn"
              title="College Dashboard"
              :to="{ name: 'college-dashboard', query: { id: row.id }}"
            >
              <font-awesome-icon :icon="['fas', 'tachometer']" class="icon alt" />
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SuperAdminCollegeTable',

  props: {
    colleges: {
      type: Array,
      required: true
    },

    sortedColumn: {
      type: String,
      required: true
    },
    sortedAsc: {
      type: Boolean,
      required: true
    },
    onSort: {
      type: Function,
      required: true
    },

    sendMessage: {
      type: Function,
      required: true
    },
    viewCollege: {
      type: Function,
      required: true
    },
    editCollege: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      columns: [
        {
          id: 'name',
          display_label: 'College'
        },
        {
          id: 'num_students_registered',
          display_label: 'Students Registered'
        },
        {
          id: 'num_students_who_have_scheduled_a_session',
          display_label: 'Students Scheduled'
        },
        {
          id: 'num_counselors_registered',
          display_label: 'On-Campus Counselors'
        },
        {
          id: 'num_individual_sessions_scheduled',
          display_label: 'Total Individual Sessions'
        },
        {
          id: 'num_group_sessions_scheduled',
          display_label: 'Total Wellbeing Workshops'
        },
        {
          id: 'num_college_events_scheduled',
          display_label: 'Total College Events'
        },
        {
          id: 'current_individual_session_credits',
          display_label: 'Individual Credits'
        },
        {
          id: 'current_group_session_credits',
          display_label: 'Wellbeing Workshop Credits'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.overflow-scroll-table {
  max-width: 100%;
  overflow-x: auto;
}

.responsive-table {
  @include border-radius($border-radius);

  width: 100%;
  border: none;

  thead {
    background: none;
    color: white;

    th {
      position: relative;
      padding: 0.75rem;
      padding-right: $gutter;
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;

      i,
      svg {
        position: absolute;
        top: 17px;
        right: 10px;
      }

      .fa-sort {
        z-index: 1;
        opacity: 0.2;
      }

      span {
        .fa-sort-up {
          z-index: 2;
          opacity: 0;
        }

        .fa-sort-down {
          z-index: 3;
          opacity: 0;
        }

        &.active-down {
          .fa-sort-down {
            opacity: 1;
          }
        }

        &.active-up {
          .fa-sort-up {
            opacity: 1;
          }
        }
      }

      &:hover {
        .fa-sort {
          opacity: 0.3;
        }

        span {
          .fa-sort-down {
            opacity: 1;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }

            .fa-sort-up {
              opacity: 0;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }

            .fa-sort-down {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.75rem;
        color: rgba(white, 0.87);
        border-top: 1px solid rgba(255, 255, 255, 0.25);

        a {
          color: darken($highlight-color, 5%);
        }
      }
    }
  }

  .actions {
    text-align: right;
  }

  @media (max-width: $sm-max) {
    display: block;
    border: none;

    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    tbody {
      tr {
        background: $dark-blue;
        margin-bottom: 60px;

        td {
          padding: 0.75rem;
          text-align: right;
          border-bottom: none;
          border-top: 1px solid rgba(255, 255, 255, 0.25);

          &:last-of-type {
            border-bottom: none;
          }
        }
      }
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      @include border-radius($border-radius);

      margin: 0 0 1rem 0;
      background: white;
    }

    td {
      position: relative;
      padding-left: 50%;
      border: none;
      border-bottom: $secondary-border;

      label {
        position: absolute;
        top: 12.5px;
        left: 15px;
        width: 45%;
        padding-right: 10px;
        font-weight: bold;
        white-space: nowrap;
        text-align: left;
      }
    }

    .btn-ghost {
      border-color: $primary-color;
      background: $primary-color;
      color: $btn-color;
      height: 45px;

      &:hover,
      &:focus {
        border-color: darken($primary-color, 5%);
        background-color: darken($primary-color, 5%);
        color: $btn-color;
      }
    }
  }

  .icons {
    white-space: nowrap;
    color: $green;
    text-align: right;

    .btn {
      margin-top: 3px;

      @media (min-width: $lg-min) {
        margin-top: 0;
        margin-left: 3px;
      }
    }
  }
}

.fa-btn {
  background: none;
  color: white;
  border: none;
  box-shadow: none;
}
</style>
